<div class="variation-select-container">
  <span class="form-label"> {{'edp.emarket.variation' | translate}}</span>
  <mat-form-field floatLabel="never">
    <mat-label class="select-text">{{'edp.emarket.variation.select' | translate}}</mat-label>
    <mat-select formControlName="variation" panelClass="edit-alert-variation">
      <mat-option disabled>
        <div class="d-flex justify-content-between align-items-center pt-2">
          {{'edp.emarket.variation.select' | translate}} <i class="icon-edponline-Bra-073 font-size-24 font-weight-bold pr-2 rotate-180 edit-alerts-arrow"></i>
        </div>
      </mat-option>
      @for (variation of variations$ | async; track variation) {
        <mat-option value="{{ variation.id }}">{{ variation.variation }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
